import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

import { trackEvent } from '../utils/analytics';
import '../css/HeroProducts.css';

class HeroProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      sectionTitle: {
        "zh": "一個 AI 大腦，驅動各式機器人及自動化硬體",
        "en": "One AI brain that powers any robot to work in the real world",
        "ja": "あらゆるロボットを現実世界で動かす、一つの AI ブレイン"
      },
      brainLabel: {
        "zh": "AI 大腦",
        "en": "AI BRAIN",
        "ja": "AI ブレイン"
      },
      viewAllText: {
        "zh": "查看所有產品與方案",
        "en": "View All Products & Solutions",
        "ja": "すべての製品とソリューションを見る"
      },
      // order corresponds to the four hub positions: TL, TR, BL, BR
      products: [
        {
          pos: "tl",
          image: "/assets/product/nxbot/collie.png",
          route: "/tech/collie",
          name: {
            "zh": "自主巡邏機器人",
            "en": "AI Patrol Robot Dog",
            "ja": "AI巡回ロボット犬"
          }
        },
        {
          pos: "tr",
          image: "/assets/product/nxbot/welding_robot_logo.png",
          route: "/tech/beaver",
          name: {
            "zh": "智慧焊接機器人",
            "en": "Intelligent Welding Robot",
            "ja": "スマート溶接ロボット"
          }
        },
        {
          pos: "bl",
          image: "/assets/product/nxa/pms.jpg",
          route: "/tech/pms100",
          name: {
            "zh": "AI 停車管理",
            "en": "AI Parking Management",
            "ja": "AI駐車管理"
          }
        },
        {
          pos: "br",
          image: "/assets/product/nxa/vs.png",
          route: "/tech/vs100",
          name: {
            "zh": "AI 影像安防",
            "en": "AI Video Security",
            "ja": "AI映像セキュリティ"
          }
        }
      ]
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  selectProduct(product) {
    trackEvent('select_product', {
      location: 'home_hub',
      product_name: product.name.en,
      product_route: product.route,
    });
    this.props.navigate(product.route);
  }

  // Spoke lines drawn from the central brain (500,300) out to each node.
  renderSpokes() {
    const nodes = {
      tl: [188, 118],
      tr: [812, 118],
      bl: [188, 482],
      br: [812, 482]
    };
    return (
      <svg
        className="hero-hub-spokes"
        viewBox="0 0 1000 600"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {Object.keys(nodes).map((key, i) => {
          const [x, y] = nodes[key];
          return (
            <g key={key}>
              <line
                x1="500" y1="300" x2={x} y2={y}
                className="hero-spoke-base"
              />
              <line
                x1="500" y1="300" x2={x} y2={y}
                className="hero-spoke-flow"
                style={{ animationDelay: `${i * 0.45}s` }}
              />
            </g>
          );
        })}
      </svg>
    );
  }

  renderBrain(lang) {
    return (
      <div
        className="hero-brain"
        role="button"
        tabIndex={0}
        aria-label={this.state.brainLabel[lang]}
        onClick={() => { trackEvent('select_brain', { location: 'home_hub' }); this.props.navigate('/core-technology'); }}
        onKeyDown={(e) => { if (e.key === 'Enter') { trackEvent('select_brain', { location: 'home_hub' }); this.props.navigate('/core-technology'); } }}
      >
        <span className="hero-brain-ring hero-brain-ring-1"></span>
        <span className="hero-brain-ring hero-brain-ring-2"></span>
        <span className="hero-brain-ring hero-brain-ring-3"></span>
        <svg className="hero-brain-core" viewBox="0 0 200 200">
          <defs>
            <radialGradient id="brainCoreGrad" cx="50%" cy="42%" r="60%">
              <stop offset="0%" stopColor="#2a2f12" />
              <stop offset="60%" stopColor="#13160a" />
              <stop offset="100%" stopColor="#0a0f14" />
            </radialGradient>
          </defs>
          <circle cx="100" cy="100" r="78" fill="url(#brainCoreGrad)" stroke="rgba(245,244,26,0.35)" strokeWidth="1.5" />

          {/* neural mesh */}
          <g className="hero-brain-mesh" stroke="rgba(245,244,26,0.4)" strokeWidth="1.1" fill="none">
            <line x1="62" y1="64" x2="100" y2="86" />
            <line x1="138" y1="68" x2="100" y2="86" />
            <line x1="100" y1="86" x2="70" y2="120" />
            <line x1="100" y1="86" x2="132" y2="118" />
            <line x1="70" y1="120" x2="100" y2="150" />
            <line x1="132" y1="118" x2="100" y2="150" />
            <line x1="62" y1="64" x2="70" y2="120" />
            <line x1="138" y1="68" x2="132" y2="118" />
            <line x1="100" y1="50" x2="62" y2="64" />
            <line x1="100" y1="50" x2="138" y2="68" />
          </g>

          {/* synapse nodes */}
          <g className="hero-brain-nodes" fill="var(--main-color)">
            <circle cx="100" cy="50" r="3.2" style={{ animationDelay: '0s' }} />
            <circle cx="62" cy="64" r="3.6" style={{ animationDelay: '0.3s' }} />
            <circle cx="138" cy="68" r="3.6" style={{ animationDelay: '0.6s' }} />
            <circle cx="70" cy="120" r="3.4" style={{ animationDelay: '0.9s' }} />
            <circle cx="132" cy="118" r="3.4" style={{ animationDelay: '1.2s' }} />
            <circle cx="100" cy="150" r="3.2" style={{ animationDelay: '1.5s' }} />
            <circle cx="100" cy="86" r="5" className="hero-brain-core-node" />
          </g>
        </svg>
        <span className="hero-brain-label">{this.state.brainLabel[lang]}</span>
      </div>
    );
  }

  render() {
    const lang = this.state.lang;

    return (
      <div className="hero-products">
        <div className="hero-products-inner">
          <Fade duration={800} delay={150}>
            <h2 className="hero-products-title">{this.state.sectionTitle[lang]}</h2>
          </Fade>
          <Fade duration={1000} delay={350}>
            <div className="hero-hub">
              {this.renderSpokes()}
              {this.renderBrain(lang)}
              {this.state.products.map((product, index) => (
                <div
                  key={index}
                  className={`hero-hub-node hero-hub-node-${product.pos}`}
                  onClick={() => this.selectProduct(product)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === 'Enter') this.selectProduct(product); }}
                >
                  <div className="hero-product-img-wrap">
                    <img src={product.image} alt={product.name[lang]} />
                  </div>
                  <p className="hero-product-name">{product.name[lang]}</p>
                </div>
              ))}
            </div>
          </Fade>

          <Fade duration={800} delay={500}>
            <div className="hero-products-cta">
              <button
                className="hero-products-btn"
                onClick={() => { trackEvent('view_all_products', { location: 'home_hub' }); this.props.navigate('/solutions'); }}
              >
                {this.state.viewAllText[lang]} &rarr;
              </button>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

export default HeroProducts;
